// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"5a36fc24","386":"2dd712f1","610":"fccb199a","770":"d8dcf33c","787":"eb27d367"}[chunkId] + ".chunk.js";
};